import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";
const LatestNews = lazy(() => import("@/pages/LatestNews"));
const Resources = lazy(() => import("@/pages/Resources"));
const SpaceXStock = lazy(() => import("@/pages/SpaceXStock"));
const StateGuides = lazy(() => import("@/pages/StateGuides"));
const TrumpAccountsGuide = lazy(() => import("@/pages/TrumpAccountsGuide"));
const TrumpAccountsCalculator = lazy(() => import("@/pages/TrumpAccountsCalculator"));
const TopicPage = lazy(() => import("@/pages/TopicPage"));
const Admin = lazy(() => import("@/pages/Admin"));
const ArticlePage = lazy(() => import("@/pages/ArticlePage"));
const StoriesArchive = lazy(() => import("@/pages/StoriesArchive"));
const StateGuide = lazy(() => import("@/pages/StateGuide"));
const Faqs = lazy(() => import("@/pages/Faqs"));
const Advertise = lazy(() => import("@/pages/Advertise"));
const Legal = lazy(() => import("@/pages/Legal"));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Suspense fallback={null}><Admin /></Suspense>} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/latest-news" element={<LatestNews />} />
          <Route path="/spacex-stock-price" element={<SpaceXStock />} />
          <Route path="/news" element={<StoriesArchive />} />
          <Route path="/news/:slug" element={<ArticlePage />} />
          <Route path="/trump-accounts-guide" element={<TrumpAccountsGuide />} />
          <Route path="/trump-accounts-calculator" element={<TrumpAccountsCalculator />} />
          <Route path="/topics/:slug" element={<TopicPage />} />
          <Route path="/custodial-accounts" element={<StateGuides />} />
          <Route path="/custodial-accounts/:slug" element={<StateGuide />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/about" element={<Legal page="about" />} />
          <Route path="/privacy-policy" element={<Legal page="privacy" />} />
          <Route path="/advertising-disclosure" element={<Legal page="ads" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      </BrowserRouter>
  );
}

export default App;
